import React from 'react';
import { useIntl } from 'react-intl';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import ErrorMessageHandler from '../../../../core/components/ErrorMessageHandler';

const modalBodyStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '2rem',
};

const errorIconStyle: React.CSSProperties = {
  width: '80px',
  height: '80px',
  borderRadius: '50%',
  backgroundColor: '#dc3545',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '36px',
  color: 'white',
};

export interface DetergentErrorModalProps {
  isOpen: boolean;
  errorMessage?: string | null;
  hide: () => void;
}

const DetergentErrorModal = React.memo(
  ({ isOpen, errorMessage = null, hide }: DetergentErrorModalProps) => {
    const intl = useIntl();
    const title = intl.formatMessage({ id: 'creatingDetergentsError' });
    const defaultMessage = intl.formatMessage({ id: 'creatingDetergentsErrorMessage' });
    const message = typeof errorMessage === 'string' ? errorMessage : defaultMessage;
    // parse the error message to get the error code Error: Error:
    const errorCode = message.split('Error: Error:')[1];
    return (
      <Modal
        isOpen={isOpen}
        toggle={hide}
        backdrop="static"
        keyboard={false}
        className="modal-content"
      >
        <ModalHeader>{title}</ModalHeader>
        <ModalBody style={modalBodyStyle}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
            <div style={errorIconStyle}>✕</div>
          </div>
          <div style={{ marginTop: '1rem', textAlign: 'center', marginBottom: '1rem' }}>
            <ErrorMessageHandler errorMessage={message} />
          </div>
          <button className="button" onClick={hide} style={{ marginTop: '1.5rem' }}>
            {intl.formatMessage({ id: 'close' })}
          </button>
        </ModalBody>
      </Modal>
    );
  }
);

DetergentErrorModal.displayName = 'DetergentErrorModal';

export default DetergentErrorModal;
